"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListboxContext = void 0;
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var __1 = require("..");
var react_i18next_1 = require("react-i18next");
var styles_1 = require("./styles");
exports.ListboxContext = (0, react_1.createContext)({
    options: [],
    value: [],
    setValue: function () { },
    renderedOptions: [],
    setRenderedOptions: function () { },
});
var ListboxComponent = react_1.default.forwardRef(function ListboxComponent(_a, ref) {
    var children = _a.children, className = _a.className, role = _a.role, id = _a.id, ariaLabelledBy = _a["aria-labelledby"], onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave;
    var context = (0, react_1.useContext)(exports.ListboxContext);
    var setValue = context.setValue, value = context.value, setRenderedOptions = context.setRenderedOptions, options = context.options;
    var renderedOptions = react_1.default.Children.toArray(children)
        .filter(function (child) {
        return react_1.default.isValidElement(child) && child.props.optionData.id !== undefined;
    })
        .map(function (child) { return child.props.optionData; });
    var previousRenderedOptionsRef = react_1.default.useRef([]);
    if (JSON.stringify(renderedOptions) !==
        JSON.stringify(previousRenderedOptionsRef.current)) {
        setRenderedOptions(renderedOptions);
        previousRenderedOptionsRef.current = renderedOptions;
    }
    var handleSelectAll = function () {
        setValue(function (prevValue) {
            var prevIdsSet = new Set(prevValue.map(function (option) { return option.id; }));
            var newOptions = renderedOptions.filter(function (option) { return !prevIdsSet.has(option.id); });
            return __spreadArray(__spreadArray([], __read(prevValue), false), __read(newOptions), false);
        });
    };
    var handleClearAll = function () {
        var renderedOptionIds = new Set(renderedOptions.map(function (option) { return option.id; }));
        setValue(function (prevValue) {
            return prevValue.filter(function (option) { return !renderedOptionIds.has(option.id); });
        });
    };
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement(styles_1.ListBoxWrapper, null,
        react_1.default.createElement("ul", { className: className, role: role, id: id, "aria-labelledby": ariaLabelledBy, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, ref: ref },
            react_1.default.createElement(material_1.ListSubheader, null,
                react_1.default.createElement(styles_1.ActionContainer, null,
                    react_1.default.createElement(__1.Button, { onClick: handleSelectAll, variant: "text", "data-testid": "select-all-button" }, t('prism-header:select-all', 'Select all')),
                    (value === null || value === void 0 ? void 0 : value.length) > 0 && (react_1.default.createElement(__1.Button, { onClick: handleClearAll, variant: "text" }, t('prism-header:clear-selections', 'Clear selections'))))),
            react_1.default.Children.map(children, function (child) {
                if (react_1.default.isValidElement(child)) {
                    return child;
                }
                return null;
            })),
        react_1.default.createElement(styles_1.DividerContainer, null),
        react_1.default.createElement(styles_1.RecordsCountListSubheader, null,
            react_1.default.createElement(styles_1.RecordsCountContainer, null,
                react_1.default.createElement(__1.Typography, { variant: "body2" }, "".concat(value.length, " of ").concat(options.length))))));
});
var MultiSelectAutocomplete = function (_a) {
    var value = _a.value, setValue = _a.setValue, options = _a.options, label = _a.label, disabled = _a.disabled, inputValue = _a.inputValue, onInputChange = _a.onInputChange, error = _a.error, helperText = _a.helperText, labelId = _a.labelId;
    var _b = __read((0, react_1.useState)([]), 2), renderedOptions = _b[0], setRenderedOptions = _b[1];
    var renderInputWrapperRef = react_1.default.useRef(null);
    (0, react_1.useEffect)(function () {
        if (renderInputWrapperRef.current) {
            renderInputWrapperRef.current.scrollTop =
                renderInputWrapperRef.current.scrollHeight;
        }
    }, [inputValue]);
    return (react_1.default.createElement(exports.ListboxContext.Provider, { value: {
            options: options,
            value: value,
            setValue: setValue || (function () { }),
            renderedOptions: renderedOptions,
            setRenderedOptions: setRenderedOptions,
        } },
        react_1.default.createElement(styles_1.AutocompleteWrapper, null,
            react_1.default.createElement(__1.Autocomplete, { "data-testid": "multi-select-autocomplete", multiple: true, id: "multi-select-autocomplete", options: options, ListboxComponent: ListboxComponent, value: value, onChange: function (event, newValue) {
                    if (setValue)
                        setValue(newValue);
                }, onInputChange: onInputChange, inputValue: inputValue, PopperComponent: styles_1.StyledPopper, disableCloseOnSelect: true, getOptionLabel: function (option) { return option[labelId || 'label']; }, isOptionEqualToValue: function (option, value) { return option.id === value.id; }, renderOption: function (props, option, _a) {
                    var selected = _a.selected;
                    return (
                    // @ts-ignore - optionData is not a valid prop for MenuItem but no idea what it should do
                    react_1.default.createElement(__1.MenuItem, __assign({}, props, { value: option.id, optionData: option }),
                        react_1.default.createElement(__1.Checkbox, { checked: selected }),
                        react_1.default.createElement(__1.ListItemText, { primary: option[labelId || 'label'] })));
                }, renderTags: function (value, getTagProps) { return (react_1.default.createElement(styles_1.RenderInputWrapper, { ref: renderInputWrapperRef }, value.map(function (option, index) { return (react_1.default.createElement(__1.Chip, __assign({ size: "small", label: option[labelId || 'label'] }, getTagProps({ index: index })))); }))); }, renderInput: function (params) { return (react_1.default.createElement(styles_1.StyledTextField, __assign({ label: label, error: error, helperText: helperText }, params))); }, disabled: disabled }))));
};
exports.default = MultiSelectAutocomplete;
//# sourceMappingURL=index.js.map